import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { ORDER_CORE_FEATURE, ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root'

@NgModule({
  imports: [
    OrderRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [ORDER_FEATURE]: {
          module: () => import('@spartacus/order').then(m => m.OrderModule),
        },
        [ORDER_CORE_FEATURE]: ORDER_FEATURE,
      },
    }),
  ],
})
export class OrderFeatureModule {
}
